import useFetchList from "./useFetchList";

export interface WayType {
    id: string;
    name: string;
    code: string;
}

interface WayTypeApiResponse {
    WAY_TYPE_ID: string;
    WAY_TYPE_NAME: string;
}

const mapWayTypes = (items: WayTypeApiResponse[]): WayType[] =>
    items.map((w) => ({
        id: w.WAY_TYPE_ID,
        name: w.WAY_TYPE_NAME,
        code: w.WAY_TYPE_ID,
    }));

const useGetWayTypes = () => {
    const { data, loading, error } = useFetchList<WayTypeApiResponse, WayType>({
        endpoint: "/getWayType",
        transform: mapWayTypes,
    });
    return { data, loading, error };
};

export default useGetWayTypes;
